import { useUiStorePersistent } from '@/shared/store/ui-store';
import { resolveLogoUrl } from '@/utils/logo';

export function MaintenanceScreen() {
  const { isDarkMode } = useUiStorePersistent();

  return (
    <div className="bg-background flex h-screen w-full flex-col items-center justify-center text-center">
      <h1 className="mb-4 text-2xl font-bold">Systemwartung</h1>

      <p className="text-muted-foreground mb-6 max-w-md">
        Das System wird derzeit gewartet, um Ihre Erfahrung zu
        verbessern. Bitte versuchen Sie es später erneut.
      </p>

      <div className="text-muted-foreground text-sm">
        Vielen Dank für Ihre Geduld.
      </div>

      <img
        src={resolveLogoUrl(isDarkMode)}
        alt="logo"
        className="mt-6 h-5"
      />
    </div>
  );
}
